import { filters } from '@/sui/tools/regions'

const common = {
  none: [
    {
      name: '(Aucun)',
      filter: ''
    },
    {}
  ],

  convention: [
    {
      name: 'Chartes vides',
      filter: '$cs:0'
    },
    {
      name: 'Chartes en cours de remplissage',
      filter: '$cs:4'
    },
    {
      name: 'Chartes en attente',
      filter: '$cs:1'
    },
    {
      name: 'Chartes acceptées',
      filter: '$cs:2'
    },
    {
      name: 'Chartes refusées',
      filter: '$cs:3'
    },
    {}
  ],

  notBactADI: [
    {
      name: 'Non inscrits à Bact ADI',
      filter: '$b~non'
    }
  ],

  surv: function (p) {
    return [
      {
        name: 'Surveillance OK (charte + fiche étab + tout pfd)',
        filter: '$es:OK'
      },
      {
        name: 'Surveillance partiellement OK (charte + fiche étab + au moins 1 pfd)',
        filter: '$es:POK'
      },
      {
        name: 'Surveillance NOK (charte + fiche étab + pas de pfd)',
        filter: '$es:NOK'
      },
      {},
      {
        name: 'Surveillance avec données OK (type étab + au moins 1 pfd)',
        filter: `($b~"pfd.$" ou $${p}~"pfd.$" ou $ri~"pfd.$" ou $di~"pfd.$" ou $ni~"pfd.$") et $ty ~ .`
      },
      {
        name: 'Au moins un module [pf]',
        filter: `$b~"pf.$" ou $${p}~"pf.$" ou $ri~"pf.$" ou $di~"pf.$" ou $ni~"pf.$"`
      },
      {
        name: 'Au moins un module [pfd]',
        filter: `$b~"pfd.$" ou $${p}~"pfd.$" ou $ri~"pfd.$" ou $di~"pfd.$" ou $ni~"pfd.$"`
      }
    ]
  },

  prot: [
    {
      name: 'Inscrit à au moins un protocole',
      filter: '$b~oui ou $ea~oui ou $ri~oui ou $di~oui ou $ni~oui'
    },
    {
      name: 'Inscrit à aucun protocole',
      filter: '$b~non et $ea~non et $ri~non et $di~non et $ni~non'
    },
    {
      name: 'Inscrits à un protocole avec uf',
      filter: '$ea~oui ou $ri~oui ou $ni~oui ou $di~oui'
    },
    {},
    {
      name: 'Inscrits à OBSERVA4',
      filter: '$o4~oui'
    }
  ]
}

const withExplaur = [
  {
    title: 'Statut',
    list: [
      ...common.none,
      ...common.convention,
      ...common.surv('ea')
    ]
  },

  {
    title: 'Protocoles',
    list: [
      ...common.none,
      ...common.notBactADI,
      ...common.prot,
      {
        name: 'Inscrits à RÉA-explAUR',
        filter: '$rx~oui'
      },
      {
        name: `RÉA-explAUR => écouvillons à envoyer`,
        filter: '$rxs~attente'
      }
    ]
  },

  {
    title: 'Régions',
    list: [
      ...common.none,
      ...filters
    ],
    active: ls => ls.isUser
  }
]
export default {
  '2019': [
    {
      title: 'Statut',
      list: [
        ...common.none,
        ...common.convention,
        ...common.surv('rb')
      ]
    },
    {
      title: 'Protocoles',
      list: [
        ...common.none,
        ...common.notBactADI,
        {
          name: 'Inscrit à au moins un protocole',
          filter: '$b~oui ou $rb~oui ou $ri~oui ou $di~oui ou $ni~oui'
        },
        {
          name: 'Inscrit à aucun protocole',
          filter: '$b~non et $rb~non et $ri~non et $di~non et $ni~non'
        },
        {
          name: 'Inscrits à un protocole avec uf',
          filter: '$rb~oui ou $ri~oui ou $ni~oui ou $di~oui'
        }
      ]
    },
    {
      title: 'Régions',
      list: [
        ...common.none,
        ...filters
      ],
      active: ls => ls.isUser
    }
  ],

  '2020': [
    {
      title: 'Statut',
      list: [
        ...common.none,
        ...common.convention,
        ...common.surv('ea')
      ]
    },
    {
      title: 'Protocoles',
      list: [
        ...common.none,
        ...common.notBactADI,
        ...common.prot,

        {
          name: 'Inscrits à Réa-Sink',
          filter: '$rs~oui'
        },
        {
          name: `Réa-Sink => écouvillons à envoyer`,
          filter: '$rss~attente'
        },
        {
          name: `Réa-sink => écouvillons en route pour le labo`,
          filter: '$rss~"retournés"'
        },
        {
          name: `Réa-sink => écouvillons au labo`,
          filter: '$rss~"labo"'
        }
      ]
    },
    {
      title: 'Régions',
      list: [
        ...common.none,
        ...filters
      ],
      active: ls => ls.isUser
    }
  ],

  '2021': withExplaur,
  '2022': withExplaur,
  '2023': withExplaur,
  '2024': withExplaur,
  '2025': withExplaur,
  '2026': withExplaur
}
